import { render, staticRenderFns } from "./fontColor.vue?vue&type=template&id=719c905f&scoped=true"
import script from "./fontColor.vue?vue&type=script&lang=js"
export * from "./fontColor.vue?vue&type=script&lang=js"
import style0 from "./fontColor.vue?vue&type=style&index=0&id=719c905f&prod&lang=less"
import style1 from "./fontColor.vue?vue&type=style&index=1&id=719c905f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719c905f",
  null
  
)

export default component.exports